import { render, staticRenderFns } from "./vsDropdownItem.vue?vue&type=template&id=0318929c&lang=html"
import script from "./vsDropdownItem.vue?vue&type=script&lang=js"
export * from "./vsDropdownItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports